<template>
    <Dialog ref="dialog" @dismiss="resolve(false)">
        <template v-slot:title>Neuložené změny</template>
        <template v-slot:body>
            <p>Na aktuální stránce máte neuložené změny.</p>
        </template>
        <template v-slot:buttons>
            <button type="button" class="btn btn-primary" @click="resolve(true)" data-bs-dismiss="modal">
                Uložit
            </button>
            <button type="button" class="btn btn-secondary" @click="resolve(false)" data-bs-dismiss="modal">
                Zahodit
            </button>
        </template>
    </Dialog>
</template>

<script lang="ts">
import Dialog from '@/components/common/Dialog.vue';
import {noop} from 'lodash-es';
import {defineComponent, ref} from 'vue';

export default defineComponent({
    components: {Dialog},
    setup(props, {expose}) {
        const dialog = ref<InstanceType<typeof Dialog> | null>(null);
        let resolvePromise: (save: boolean) => void = noop;

        function resolve(save: boolean): void {
            resolvePromise(save);
        }

        function show(): Promise<boolean> {
            dialog.value!.show();

            return new Promise<boolean>((r) => resolvePromise = r)
                .finally(() => resolvePromise = noop);
        }

        expose({show});

        return {dialog, resolve, show};
    },
});
</script>
